import PosterDefault from '../../../../shared/assets/images/png/posterDefault.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

/**
 * Styled image component for event poster in pause ad modal.
 * Displays the content poster with white border and rounded corners.
 */
const PauseAdPoster = styled.img<React.CSSProperties>`
  position: fixed;
  top: ${408 * Screen.widthRatio}px;
  left: ${86 * Screen.widthRatio}px;
  width: ${246 * Screen.widthRatio}px;
  height: ${350 * Screen.widthRatio}px;
  border-radius: ${15 * Screen.widthRatio}px;
  box-shadow: 0 0 0 ${4 * Screen.widthRatio}px #fff;
`;

export default withImage(PauseAdPoster, true, PosterDefault);
